<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><span class="smallcaps">FOR</span></span></p>
<p class="ded1"><span>PVT. BILL BISHOP</span></p>
<p class="ded1"><span>Trusting he can fight a war</span></p>
<p class="ded1"><span>better than he plays bridge.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?d018762a